import { useAtom } from "jotai";
import { overlay_state } from "state/store.ui";

export const useToggle = () => {
  const [overlayState, setOverlayState] = useAtom(overlay_state);

  const closeAll = (prev) =>
    Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {});

  const toggleOverlay = (name, options = {}) => {
    const { exclusive = true, open } = options;

    setOverlayState((prev) => {
      // Explicit open or close, without touching others
      if (open === true)  return { ...(exclusive ? closeAll(prev) : prev), [name]: true };
      if (open === false) return { ...prev, [name]: false };

      // Toggle target; close all others first if exclusive
      const base = exclusive ? closeAll(prev) : prev;
      return { ...base, [name]: !prev[name] };
    });
  };

  return { overlayState, toggleOverlay };
};